import { Stepper } from "@omony/ui";
import { useT } from "./common.js";

export const STEPS = [
  "sprache",
  "patient",
  "bestaetigen",
  "ersteinschaetzung",
  "warten",
  "video",
  "ergebnis",
  "abrechnung",
] as const;
export type StepId = (typeof STEPS)[number];

/** Geführter Stepper (A04): acht Schritte, der aktuelle kommt aus dem Serverzustand */
export function FlowStepper({ step }: { step: StepId }) {
  const t = useT();
  return (
    <Stepper
      label={t("console.step.label")}
      steps={STEPS.map((id) => ({ id, label: t(`console.step.${id}`) }))}
      currentIndex={STEPS.indexOf(step)}
    />
  );
}
